exports = module.exports = require("../../../../../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ItemQestionBlock{position:absolute;width:200px;height:50px;background:#fff;border:1px solid #d8d8d8;border-radius:0;display:flex;align-items:center;justify-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Question/components/Questions/components/Item/components/Answers/components/AnswerType6/components/LineLabel/style.scss
// module id = 5206
// module chunks = 0